// extracted by mini-css-extract-plugin
module.exports = {"section":"s_l","row":"s_bm","header":"s_R","list":"s_bn","listSquare":"s_bp"};